
<!-- Выбор атрибута из списка и установ значения атрибута -->

<template>

	<div>

		<attr_select class="mb-2" v-model="attr_key" ref="attr_select" v-on:input="attr_changed" :service="service" :is_all_attrs_editable="is_all_attrs_editable" :editable_attr_keys="editable_attr_keys" :new_modal="new_modal" :without_system="without_system" :without_bad="without_bad"/>
		<b-row class="mb-2"><b-col cols="3">Тип атрибута:</b-col><b-col>{{ attr | format_type }}</b-col></b-row>
		<b-row class="mb-2"><b-col cols="3">Ограничения:</b-col><b-col v-if="attr">{{ attr.type_info }}</b-col></b-row>

		<b-form-group :state="value_state" label="Значение" label-for="value_input" :invalid-feedback="value_invalid_feedback">

			<div v-if="attr != null && attr.type == 'bool'">

				<v-select id="value_input" v-model="value" :reduce="obj => obj.value" :options="bool_options" v-on:input="input" clearSearchOnSelect required appendToBody/>

			</div>

			<div v-else-if="attr != null && attr.type == 'number'">

				<b-form-input id="value_input" v-model="value" :state="value_state" :disabled="attr == null" type="number" v-on:input="input"/>

			</div>

			<div v-else-if="attr != null && attr.type == 'date'">

				<date_picker v-model="value" :new_modal="new_modal" v-on:input="input"/>

			</div>

			<div v-else-if="attr != null && attr.type == 'time'">

				<b-form-input v-model="value" v-mask="time_mask" placeholder="__:__:__" v-on:input="input"/>

			</div>

			<div v-else-if="attr != null && attr.type == 'datetime'">

				<b-form-input v-model="value" v-mask="datetime_mask" placeholder="__.__.____ __:__:__" v-on:input="input"/>

			</div>

			<div v-else-if="attr != null && attr.reference">

				<reference_values ref="reference_values" v-model="value" :id="attr.reference.id" v-on:input="input" :new_modal="new_modal"/>

			</div>

			<div v-else-if="attr != null && attr.mask != null">

				<b-form-input ref="input_with_mask" id="value_input" v-model="value" :state="value_state" :disabled="attr == null" v-mask="attr.mask" :placeholder="attr.placeholder" v-on:input="input"/>

			</div>

			<div v-else>

				<b-form-input id="value_input" v-model="value" :state="value_state" :disabled="attr == null" v-on:input="input"/>

			</div>

		</b-form-group>

	</div>

</template>

<script>

import api from "../../api"
import Inputmask from "inputmask"
import reference_values from "./reference"
import attr_select from "./attr_select"
import date_picker from "./date_picker"

export default
{
	props :
	{
		attrs : [],
		new_modal : Boolean,
		is_all_attrs_editable : { type : Boolean, default : () => true },
		editable_attr_keys : { type : Array, default : () => [ "attrs.cost", "attrs.UPKS" ] },
		without_system : Boolean,
		without_bad : Boolean,
		service : String,
	},

	components:
	{
		reference_values,
		attr_select,
		date_picker,
	},

	data()
	{
		return {
			
			attr : null,
			attr_key : null,

			value : null,
			value_state : null,
			value_invalid_feedback : null,

			bool_options :
			[
				{ label : "Да", value : true },
				{ label : "Нет", value : false },
			],

			datetime_mask :
			{
				mask : "#{2}.#{2}.#{4} *{1}#{1}:#{2}:#{2}",
				greedy : false,
				definitions : { "*" : { validator : "[0-2]", casing : "lower" }, "#" : { validator : "[0-9]", casing : "lower" } }
			},

			time_mask :
			{
				mask : "*{1}#{1}:#{2}:#{2}",
				greedy : false,
				definitions : { "*" : { validator : "[0-2]", casing : "lower" }, "#" : { validator : "[0-9]", casing : "lower" } }
			},

		}
	},

	filters :
	{
		format_type(attr)
		{
			if(attr == null)
				return ""

			if(attr.type == "number")
				return "Число"
			else if(attr.type == "date")
				return "Дата"
			else if(attr.type == "time")
				return "Время"
			else if(attr.type == "datetime")
				return "Дата и время"
			else if(attr.type == "bool")
				return "Булево"
			else if(attr.reference)
				return "Строка (справочник)"
			
			return "Строка"
		}
	},

	methods :
	{
		// Сменили атрибут, выставляем значение - нужно для списков
		prepare_value_field()
		{
			this.value_state = null

			if(this.attr === null || typeof this.attr == "undefined")
				this.value = ""
			else if(this.attr.type == "bool")
				this.value = true
			else
				this.value = ""

			this.$emit("input", { key : this.attr_key, value : this.value })
			this.input(this.value)
		},

		set_preset_value(value)
		{
			this.value = value
		},

		check()
		{
			const attr_state = this.$refs.attr_select.check()

			return attr_state && this.value_state
		},

		reset()
		{
			this.attr = null
			this.attr_key = null
			this.value_invalid_feedback = null

			this.prepare_value_field()
		},

		attr_changed(attr_key)
		{
			this.attr = this.attrs.find(attr => attr_key == attr.key)

			this.prepare_value_field()
			
			if(this.attr.type == "time")
			{
				var now = new Date()
				var hour = now.getHours().toString()
				var minute = now.getMinutes().toString()
				var second = now.getSeconds().toString()

				if(hour.length == 1)
					hour = "0" + hour

				if(minute.length == 1)
					minute = "0" + minute

				if(second.length == 1)
					second = "0" + second

				this.value = hour + ":" + minute + ":" + second

				this.input(this.value)
			}
			else if(this.attr.mask != null && this.$refs.input_with_mask != null)
				Inputmask(this.attr.mask).mask(this.$refs.input_with_mask.$refs.input)
		},

		input(value)
		{
			if(value == null || ( typeof value == "string" && value == "" ) )
			{
				this.value_state = false
				this.value_invalid_feedback = "Значение не может быть пустым"
				this.$emit("input", { key : this.attr_key, value : null })
			}
			else
			{
				if(this.attr.type == "number")
					value = Number(value)

				api.call(this, "cadastral_attrs", "check_value", { id : this.attr.id, value : value },
					() =>
					{
						this.value_state = true
						this.$emit("input", { key : this.attr_key, value : value })
					},
					() =>
					{
						this.value_state = false
						this.value_invalid_feedback = "Значение не соответствует типу"
						this.$emit("input", { key : this.attr_key, value : null })
					})
			}
		},
	}
}

</script>

